import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { LandingStep } from '@/components/steps/LandingStep/LandingStep';
import { CapReachedStep } from '@/components/steps/CapReachedStep';
import { EmailSentStep } from '@/components/steps/EmailSentStep';
import { MedicareCoverageStep } from '@/components/steps/MedicareCoverageStep';
import { HealthConditionsStep } from '@/components/steps/HealthConditionsStep';
import { PHQ9ScreenerStep } from '@/components/steps/PHQ9ScreenerStep';
import { GAD7ScreenerStep } from '@/components/steps/GAD7ScreenerStep';
import { TrackOfferingStep } from '@/components/steps/TrackOfferingStep';
import { NotEligibleStep } from '@/components/steps/NotEligibleStep';
import { CreateAccountStep } from '@/components/steps/CreateAccountStep';
import { ShippingStep } from '@/components/steps/ShippingStep';
import { DownloadAppStep } from '@/components/steps/DownloadAppStep';
import { CheckSMSStep } from '@/components/steps/CheckSMS/CheckSMSStep';
import { DownloadAppQRCodeStep } from '@/components/steps/DownloadAppQRCodeStep';
import { EligibilityResultStep } from '@/components/steps/EligibilityResultStep';
import { STEP_KEYS } from '@/hooks/useAppFlow';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <LandingStep /> },
      { path: 'cap-reached', element: <CapReachedStep /> },
      { path: 'email-sent', element: <EmailSentStep /> },
      { path: 'medicare-coverage', element: <MedicareCoverageStep /> },
      {
        path: 'health-conditions',
        element: <HealthConditionsStep stepKey={STEP_KEYS.ECKM_CONDITIONS} />,
      },
      {
        path: 'ckm-conditions',
        element: <HealthConditionsStep stepKey={STEP_KEYS.CKM_CONDITIONS} />,
      },
      {
        path: 'behavioral-health-conditions',
        element: <HealthConditionsStep stepKey={STEP_KEYS.BEHAVIORAL_HEALTH} />,
      },
      { path: 'phq9-screener', element: <PHQ9ScreenerStep /> },
      { path: 'gad7-screener', element: <GAD7ScreenerStep /> },
      { path: 'eligibility-result', element: <EligibilityResultStep /> },
      { path: 'track-offering', element: <TrackOfferingStep /> },
      { path: 'not-eligible', element: <NotEligibleStep /> },
      { path: 'create-account', element: <CreateAccountStep /> },
      { path: 'shipping', element: <ShippingStep /> },
      { path: 'download-app', element: <DownloadAppStep /> },
      { path: 'check-sms', element: <CheckSMSStep /> },
      { path: 'download-app-qr', element: <DownloadAppQRCodeStep /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

export { router };
